module.exports = function anonymous(it
/**/) {
var out='<div> <div class="jsa-wrapper"> <!-- heat map goes here --> </div> <div class="PMXY-wrapper"> <!-- angular emissio XY --> </div>  <div class="lambda_s-theta_s-wrapper"> <!-- lambda_signal vs theta signal --> </div>  <div class="pm-theta-phi-wrapper"> <!-- phasematching curve for crystal theta/phi --> </div> <div class="HOM-wrapper"> </div></div>';return out;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/dot-loader!./browser/library/js/templates/kitchen-sink-layout.tpl
 ** module id = 493
 ** module chunks = 1
 **/